export enum DEFAULT_COLS_KEY {
  USERNAME = 'username',
  DATE_TIME = 'dateTime',
  PATIENT_NAME = 'patientName',
  ID = 'id',
  DOB = 'dob',
  ATTEMPTS = 'attempts',
}

enum OPTAIN_BASE_COLS_KEY {
  STATUS = 'status',
  ACTIONS = 'actions',
}

export const OPTAIN_COLS_KEY = {
  ...OPTAIN_BASE_COLS_KEY,
  ...DEFAULT_COLS_KEY,
} as const;
